import Api from './config';
import { v4 as uuidv4 } from 'uuid';
import { getCookieEnvironment } from '../helpers';

const DEVICE_ID_KEY = 'collums_device_id';

const readDeviceIdCookie = () => {
    if (typeof document === 'undefined') return null;
    const match = document.cookie.match(/(?:^|;\s*)collums_device_id=([^;]+)/);
    return match ? decodeURIComponent(match[1]) : null;
};

const writeDeviceIdCookie = id => {
    if (typeof document === 'undefined') return;
    const expires = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString();
    const parts = [`${DEVICE_ID_KEY}=${encodeURIComponent(id)}`, `expires=${expires}`, 'path=/'];
    const env = getCookieEnvironment();
    if (env.domain) parts.push(`domain=${env.domain}`);
    document.cookie = parts.join('; ');
};

const getDeviceId = () => {
    let deviceId = readDeviceIdCookie();
    if (deviceId) return deviceId;
    deviceId = localStorage.getItem(DEVICE_ID_KEY);
    if (deviceId) {
        writeDeviceIdCookie(deviceId);
        return deviceId;
    }
    deviceId = uuidv4();
    writeDeviceIdCookie(deviceId);
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
    return deviceId;
};

export default class AuthApi {
    static removeToken() {
        return Api.request({
            method: 'POST',
            url: '/user/unauthorize'
        }).catch(err => err);
    }

    static lockSession() {
        return Api.request({
            method: 'POST',
            url: '/session/lock'
        }).catch(err => err);
    }

    static unlockSession() {
        return Api.request({
            method: 'POST',
            url: '/session/unlock'
        }).catch(err => err);
    }

    static async getMe() {
        return Api.request({
            method: 'GET',
            url: '/user/me'
        });
    }

    static async refreshToken() {
        return Api.request({
            method: 'GET',
            url: '/refresh-token'
        });
    }

    static lockUser() {
        return Api.request({
            method: 'POST',
            url: '/lock-user'
        });
    }

    static unlockUser(data = {}) {
        return Api.request({
            method: 'POST',
            url: '/unlock-user',
            data
        });
    }

    static isUserLocked() {
        return Api.request({
            method: 'GET',
            url: '/is-user-locked'
        });
    }

    static sendPinWebSocket(data) {
        return Api.request({
            method: 'POST',
            url: '/send-pin-websocket',
            data
        });
    }

    static isCorrectPIN(data) {
        return Api.request({
            method: 'POST',
            url: '/verify-pin-with-user',
            data: { ...data, deviceId: getDeviceId() }
        });
    }

    static deleteSessionByPin(data) {
        return Api.request({
            method: 'POST',
            url: '/session/delete-by-pin',
            data
        });
    }

    static getOrg() {
        return Api.request({
            method: 'GET',
            url: '/organisations'
        });
    }
}
